<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn depressed color="secondary" small v-on="on">{{$t('newProject')}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("project")}}</v-tab>
        <v-tab left ripple>{{$t("address")}}</v-tab>
        <v-tab left ripple>{{$t("contact")}}</v-tab>
        <v-tab-item>
          <v-divider></v-divider>
          <v-card flat>
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="d-flex flex-wrap justify-content-center container">
                <div class="flex-fill">
                  <v-text-field
                    outlined
                    dense
                    :rules="rules($t('building'))"
                    counter="512"
                    required
                    v-model="name"
                    v-bind:label="$t('name')"
                  ></v-text-field>
                  <v-text-field
                    :rules="rules($t('building'))"
                    required
                    outlined
                    counter="512"
                    dense
                    v-model="buildingName"
                    v-bind:label="$t('building')"
                  ></v-text-field>
                  <!-- <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  outlined
                  dense
                  v-model="installers"
                  :items="allInstallers"
                  v-bind:label="$t('installer')"
                  chips
                  item-value="id"
                  item-text="firstname"
                  multiple
                  return-object
                >
                </v-select> -->
                </div>
                <div class="flex-fill d-flex">
                  <image-uploader
                    :preview="false"
                    class="mx-auto my-auto"
                    style="min-width: 245px"
                    :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                    capture="environment"
                    :debug="1"
                    :quality="0.8"
                    accept=".jpg, .png"
                    :autoRotate="true"
                    outputFormat="verbose"
                    @input="setImage"
                    @onUpload="loading = true"
                    @onComplete="loading= false"
                  >
                    <label for="fileInput" slot="upload-label">
                      <div class="mx-auto my-auto text-center">
                        <v-icon v-if="!image" large>add_photo_alternate</v-icon>
                        <template v-else>
                          <v-img
                            height="245"
                            width="245"
                            aspect-ratio="1"
                            :src="(image == null) ? emptyImage : image"
                          ></v-img>
                          <a class="primary--text">{{$t('changeImage')}}</a>
                        </template>
                      </div>
                    </label>
                  </image-uploader>
                </div>
              </div>
              <!-- <v-list-item two-line>
                <v-list-item-title class="headline"></v-list-item-title>
                <v-list-item-avatar tile size="150"></v-list-item-avatar>
              </v-list-item>-->
            </v-form>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-divider></v-divider>
          <v-card flat>
            <v-card-text>
              <v-text-field outlined dense v-model="street" v-bind:label="$t('street')"></v-text-field>
              <v-text-field outlined dense v-model="no" v-bind:label="$t('number')"></v-text-field>
              <v-text-field outlined dense v-model="postalcode" v-bind:label="$t('postalcode')"></v-text-field>
              <v-text-field outlined dense v-model="city" v-bind:label="$t('city')"></v-text-field>
              <v-text-field outlined dense v-model="country" v-bind:label="$t('country')"></v-text-field>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-divider></v-divider>
          <v-card flat>
            <v-card-text>
              <v-text-field outlined dense v-model="contactName" v-bind:label="$t('name')"></v-text-field>
              <v-text-field outlined dense v-model="contactFunction" v-bind:label="$t('contactFunction')"></v-text-field>
              <v-text-field outlined dense v-model="mobile" v-bind:label="$t('mobile')"></v-text-field>
              <v-text-field outlined dense v-model="email" v-bind:label="$t('email')"></v-text-field>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="close">{{$t('close')}}</v-btn>
        <v-btn text color="primary" @click="save">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
export default {
  name: "addProject",
  data: () => ({
    valid: false,
    dialog: false,
    name: null,
    buildingName: null,
    image: null,
    hasImage: false,
    loading: false,
    street: null,
    no: null,
    postalcode: null,
    city: null,
    country: null,
    contactName: null,
    mobile: null,
    email: null,
    valid: true,
    emptyImage: require("@/assets/empty.png"),
    installers: [],
    allInstallers: null,
    contactFunction: null,
  }),
  mounted(){
    // this.getAllInstallers();
  },
  methods: {
    close() {
      this.dialog = false;
    },
    rules(property = this.$t('name')) {
      let rules = [
        v => !!v || `${property} ${this.$t("required")}`,
        v => (v && v.length <= 512) || ""
      ];
      return rules;
    },
    setImage: function(output) {
      this.hasImage = true;
      this.image = output.dataUrl;
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.valid) {
          const newProject = {
            id: uuid.v4(),
            name: this.name,
            image: this.image ? this.image : null,
            buildingName: this.buildingName,
            status: "OPEN",
            createdBy: localStorage.getItem("user"),
            modifiedBy: localStorage.getItem("user"),
            street: this.street,
            no: this.no,
            postalcode: this.postalcode,
            city: this.city,
            country: this.country,
            contactName: this.contactName,
            mobile: this.mobile,
            email: this.email,
            contactFunction: this.contactFunction
          };
          this.$emit("add-project", newProject);
          this.close();
        }
      }
    },
    async getAllInstallers() {
      try {
        let res = await this.$http.getInstallers();
        this.allInstallers = res.data;
      } catch (err) {
        console.log(err);
      }
    },
  }
};
</script>


<style>
#fileInput {
  display: none;
}
.img-preview {
  height: 150px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Projects/AddProject.vue